import {
  Box,
  Column,
  FormField,
  InputTextField,
  Radio,
  RadioGroup,
  Row,
} from '@tempmee/react';
import { CollapsibleCard } from '../../../../commonComponents';
import { ChangeAccountPhoto } from '../../../profile/components/ChangeAccountPhoto';
import { useFormContext } from '../../hooks/useFormContext';
import { CardTitle } from '../CardTitle';
import { Divider } from '../Divider';
import { PrimaryPracticeField } from './components/PrimaryPracticeField';
import { useOfficeProfile } from './hooks/useOfficeProfile';

const TwoColumnGrid = ({ children }) => (
  <Box
    style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridColumnGap: 12,
      maxWidth: '100%',
      boxSizing: 'border-box',
    }}
  >
    {children}
  </Box>
);

export const OfficeProfileCard = ({ isOpen, onToggle }) => {
  const {
    register,
    setValue,
    control,
    formState: { errors },
  } = useFormContext();
  const { formValues, isValid } = useOfficeProfile(control);

  return (
    <CollapsibleCard
      TitleComponent={() => (
        <CardTitle name="Office Profile" showWarningIcon={!isOpen && !isValid} />
      )}
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <Column gap={5} px={20} style={{ marginBottom: 40 }}>
        {/* Photo + name/website */}
        <Row gap={5}>
          <Box style={{ marginTop: 24 }}>
            <ChangeAccountPhoto />
          </Box>

          <Column style={{ flex: 1 }} gap={4}>
            <FormField label="Office Name" required>
              <InputTextField
                isError={!!errors.officeName}
                {...register('officeName', { required: true })}
              />
            </FormField>

            <FormField label="Website" optional>
              <InputTextField
                placeholder="Company Website"
                {...register('website')}
              />
            </FormField>
          </Column>
        </Row>

        {/* Primary office contact */}
        <Column gap={2} style={{ marginTop: 12 }}>
          <FormField label="Primary Office Contact:" optional>
            <TwoColumnGrid>
              <FormField label="First Name" required>
                <InputTextField
                  isError={!!errors.dentistFirstName}
                  {...register('dentistFirstName', { required: true })}
                />
              </FormField>

              <FormField label="Last Name" required>
                <InputTextField
                  isError={!!errors.dentistLastName}
                  {...register('dentistLastName', { required: true })}
                />
              </FormField>
            </TwoColumnGrid>
          </FormField>
        </Column>

        {/* Additional contact */}
        <Column gap={2} style={{ marginTop: 12 }}>
          <FormField label="Additional Contact:" optional>
            <TwoColumnGrid>
              <FormField label="First Name" optional>
                <InputTextField
                  {...register('additionalContactFirstName')}
                />
              </FormField>

              <FormField label="Last Name" optional>
                <InputTextField
                  {...register('additionalContactLastName')}
                />
              </FormField>
            </TwoColumnGrid>
          </FormField>
        </Column>

        <Divider />

        {/* Office type */}
        <FormField label="Are you a private practice or DSO?">
          <RadioGroup
            value={formValues.officeType}
            onChange={(value) => setValue('officeType', value)}
            orientation="vertical"
          >
            <Column gap={5} style={{ marginLeft: 40 }}>
              <Radio value="private_practice_independent" label="Private Practice (Independent Office)" />
              <Radio value="private_practice_multi" label="Private Practice (Part of a Multi-Office Group)" />
              <Radio value="dso" label="DSO" />
            </Column>
          </RadioGroup>
        </FormField>

        <Divider />

        <PrimaryPracticeField />
      </Column>
    </CollapsibleCard>
  );
};
